import React__default from 'react';
import styled, { css } from 'styled-components';
import { getColor } from '../styles/stylePropTypes.js';

const SIZE = {
    // 18px
    xlarge: 1.125,
    // 16px
    large: 1,
    // 14px
    medium: 0.875,
    // 12px
    small: 0.75
};
const WEIGHT = {
    xbold: 800,
    bold: 600,
    semibold: 500,
    regular: 300
};
const TruncateCSS = css`
  display: flex;
  position: relative;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 1.25em;
`;
const TextElement = styled.span`
  color: ${(props)=>props.color ? getColor(props.color, props.theme) : "inherit"};
  font-size: ${(props)=>props.size ? `${SIZE[props.size]}rem` : "inherit"};
  line-height: 1.5;
  font-weight: ${(props)=>props.weight ? WEIGHT[props.weight] : "inherit"};
  text-align: ${(props)=>props.align};
  ${(props)=>props.$truncate && TruncateCSS}

  /* capsize calcs to reposition text - see https://seek-oss.github.io/capsize/ */
  &::before {
    content: '';
    margin-top: -0.3758em;
    display: block;
    height: 0;
  }
  &::after {
    content: '';
    margin-bottom: -0.4628em;
    display: block;
    height: 0;
  }

  /* Disable capsize on nested Texts to prevent alignment issues */
  & [data-hpy-web-text] {
    &::before,
    &::after {
      display: none;
    }
  }
`;
const TextTruncateInnerElement = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  width: 100%;
`;
/**
 * generic text component,
 * abstracts usage of plain text & keeps all text consistent with system
 */ const Text = ({ size ="large" , truncate =false , children , ...props })=>{
    return React__default.createElement(TextElement, {
        "data-hpy-web-text": true,
        ...props,
        size: size,
        "$truncate": truncate
    }, !truncate && children, !!truncate && React__default.createElement(TextTruncateInnerElement, null, children));
};
Text.dataId = "data-hpy-web-text";
Text.displayName = "Text";

export { Text };
